function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

$(document).ready(function($) {
  /** Add role attribute to presentation tags */
  $('br').attr('role','presentation');
  $('hr').attr('role','presentation');

  /** Add role attribute to table tags */
  $('table').attr('role','none');
  $('thead').attr('role','none');
  $('tbody').attr('role','none');
  $('tr').attr('role','none');
  $('td').attr('role','none');  

  /** Allows logo-list marquee animation to be paused */
  $('.animation-pauser-button').on('click', function(){
    $(this).toggleClass('pressed');
    
    $('.logo-list').toggleClass('animation-paused');
    $('.multiplier-value').toggleClass('animation-paused');
    $('.banner-box').toggleClass('animation-paused');
    $('.features--zoom-image .zoom-image').toggleClass('animation-paused');
    $('div[data-animation="pausable"] div').toggleClass('animation-paused');
    
    if($(this).hasClass('pressed')) {
      $(this).html('Play Animations');
    } else {
      $(this).html('Pause Animations');
    }
  });

  $('.custom-btn-aria-label .button').removeAttr('aria-label');
  
  /** Covert Role for Replo */
    $('div[data-role="list"]').attr('role','list');
    $('div[data-role="list"]').removeAttr('data-role');
    $('div[data-role="listitem"]').attr('role','listitem');
    $('div[data-role="listitem"]').removeAttr('data-role');
    $('div[data-aria-label="replovideo"]').attr('aria-label','Real superfood formulated by real doctors');
    $('div[data-aria-label="replovideo"]').removeAttr('data-aria-label');
    $('div[data-aria-label="whatisfog"]').attr('aria-label','What is Field of Greens');
    $('div[data-aria-label="whatisfog"]').removeAttr('data-aria-label');
  
  /** MegaMenu Slider */
  $('#megamenu-visible-detect').on('change', function() {
    $('.mega-menu-tab .menu-tab-header .tab-item').removeClass('hover');

    setTimeout(() => {
      if ( $(this).val() == 'true' ) {
        // Only initialize Slick if not already initialized
        if (!$('.mega-menu-tab .menu-item-content').hasClass('slick-initialized')) {
          $('.mega-menu-tab .menu-item-content').slick({
            infinite: true,
            slidesToShow: 6,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            prevArrow: '<button class="slick-prev slick-arrow" aria-label="previous"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path d="M0 4L4 0L4.8 0.8L1.6 4L4.8 7.2L4 8L0 4Z" fill="#343740"/></svg></button>',
            nextArrow: '<button class="slick-next slick-arrow" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8" fill="none"><path d="M5 4L1 0L0.2 0.8L3.4 4L0.2 7.2L1 8L5 4Z" fill="#343740"/></svg></button>',
            responsive: [
              {
                breakpoint: 1600,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1
                }
              },
              {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
              },
              {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
              }
            ]
          });
          // Force recalculation after initialization to fix width issues
          setTimeout(() => {
            $('.mega-menu-tab .menu-item-content').slick('setPosition');
          }, 50);
        } else {
          // $('.mega-menu-tab .menu-item-content').slick('unslick');
          $('.mega-menu-tab .menu-tab-content .menu-item-content').removeClass('active');
          $('.mega-menu-tab .menu-item-content:first-child').addClass('active');
          // Recalculate positions when reopening
          $('.mega-menu-tab .menu-item-content').slick('setPosition');
        }
      }
    }, 200);
  });

  $('.mega-menu-tab .menu-tab-header .tab-item').on('mouseover', function() {
    var $this = $(this)
        id = $this.attr('id');

    $('.mega-menu-tab .menu-tab-header .tab-item').removeClass('hover');
    $this.addClass('hover');
    $('.mega-menu-tab .menu-tab-content .menu-item-content').removeClass('active');
    $('.mega-menu-tab .menu-tab-content .menu-item-content[data-id="'+ id +'"]').addClass('active');
    $('.mega-menu-tab .menu-tab-content .menu-item-content[data-id="'+ id +'"]').slick('setPosition');
  });

  /** Product List Slide */
  var productListLopping = setInterval(function() {
    if ( $('.product-list--carousel-custom').length > 0 ) {
      $('.product-list--carousel-custom').each(function() {
        var $this = $(this),
            dots = $this.data('dots'),
            column = $this.data('column');
    
        $this.slick({
          infinite: true,
          slidesToShow: column,
          slidesToScroll: 1,
          arrows: true,
          dots: dots == 'true' ? true : false,
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="previous" data-test="test"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M1.7998 9L10.7998 18L12.5998 16.2L5.3998 9L12.5998 1.8L10.7998 0L1.7998 9Z" fill="black"/></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="next"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M16.2002 9L7.2002 0L5.4002 1.8L12.6002 9L5.4002 16.2L7.2002 18L16.2002 9Z" fill="black"/></svg></button>',
          responsive: [
            {
              breakpoint: 1400,
              settings: {
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                arrows: false,
                dots: true
              }
            }
          ]
        });
        // Ensure attribute is applied after initialization
        setTimeout(function() {
            $('.slick-track').attr('role', 'list');
        }, 500);
      });

      clearInterval(productListLopping);
      return;
    }  
  }, 500);

  /** Home Testimonials */
  $('.testimonial-quote-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100,
    asNavFor: '.testimonial-slider',
    prevArrow: '<button class="slick-prev slick-arrow" aria-label="previous"><svg width="50" height="18" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow" aria-label="next"><svg width="50" height="18" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          adaptiveHeight: true,
        }
      },
    ]
  });
  
  $('.testimonial-slider').slick({
      infinite: true,
      slidesToShow: 1,        
      variableWidth: true,
      centerMode: false,
      focusOnSelect: true,
      asNavFor: '.testimonial-quote-slider',     
      arrows: false,
      dots: false,   
      responsive: [{
          breakpoint: 768,
          settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              variableWidth: false,
              centerMode: true
          }
      }]
  });

  /** Gift Message */
  $('.product-info-inner .gift-message__inner').slick({
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false
  });

  /** Product Accordion */
  $('.accordion-item .accordion-head').on('click', function() {
    var $this = $(this);

    if ( ! $this.hasClass('active') ) {
      $('.accordion-item .accordion-head').removeClass('active');
      $('.accordion-item .accordion-content').slideUp();
      $this.addClass('active');
      $this.next('.accordion-content').slideDown();
    } else {
      $('.accordion-item .accordion-head').removeClass('active');
      $('.accordion-item .accordion-content').slideUp();
    }
  });

  /** Product Ingredient */
  $('.product-ingrediants .circle').on('click', function(e) {
    var insideIndex = $(this).attr('index');
    $('.product-ingrediants .circle').removeClass('active');
    $(this).addClass('active');
    $('.product-ingrediants .description-container .description').removeClass('active');
    $('.product-ingrediants .description-container .description[index="' + insideIndex + '"]').addClass('active');
  });

  /** Produvt Nutrition Video */
  $('.product-nutrition-wrapper .video-popup-play').on('click', function() {
    $('.modal-nutrition-video').addClass('shown');
  });

  $('.modal-nutrition-video .video-popup-close').on('click', function() {
    $('.modal-nutrition-video').removeClass('shown');
  });

  /** Collectio bar scroll automatically */
  if ( $('.collection-banner-inner .collection-item.current-item').length > 0 ) {
    var activeCollectionPos = $('.collection-banner-inner .collection-item.current-item').position().left;
    $('.collection-banner-wrapper').animate({
      scrollLeft: $('.collection-banner-wrapper').offset().left + activeCollectionPos - 80
    }, 400);
  }

  /** Mobile Footer menu accordion */
  $('.footer__block--links .h6').on('click', function() {
    $(this).toggleClass('active');
    $(this).next('ul').slideToggle(250);
  });

  /** Mobile Header action */
  $('.header__primary-nav > button').on('click', function(e) {
    if ( $(window).scrollTop() < 47 ) {
      $('html, body').animate({
        scrollTop: $('header').offset().top
      }, 200);
    }
  });

  $('.header-sidebar__megamenud-drop').on('click', function() {
    $(this).toggleClass('active');
    $(this).next('.mega-menu-mobile').slideToggle(250);
  });

  /** Cart Drawer Selling Plan Update */
  $('body').on('click', '.line-item-bottom .upgrade-plan', function() {
    var $this = $(this),
        key = $this.data('key'),
        planID = $this.data('selling-plan-id'),
        quantity = $this.parents('.line-item').find('input.quantity-selector__input').val(),
        sections = $('.shopify-section--cart-drawer').attr('id').replace('shopify-section-', '');
  
    $.ajax({ // Attach Date, Preference
      type: 'POST',
      url: '/cart/change.js',
      data: {
        'id': key,
        'quantity': quantity,
        'selling_plan': planID,
        'sections': sections
      },
      dataType: 'json',
      beforeSend: function () {
        $this.parent('.line-item-bottom').find('.upgrading-plan').removeClass('hidden');
        $this.parent('.line-item-bottom').find('.upgrade-plan').addClass('hidden');
      },
      error: function(error) {
        console.log(error);
      },
      success: function(response) {
        changeLineItemContent_fn($this[0], key, response);
      }
    });
  });

  $('body').on('change', '.line-item-bottom .plan-selection', function() {
    var $this = $(this),
        key = $this.data('key'),
        planID = $this.val(),
        quantity = $this.parents('.line-item').find('input.quantity-selector__input').val(),
        selectedID = $this.data('selected-id'),
        sections = $('.shopify-section--cart-drawer').attr('id').replace('shopify-section-', '');

    if ( planID != selectedID ) {
      planID = planID == 'onetime' ? null : planID;
      
      $.ajax({ // Attach Date, Preference
        type: 'POST',
        url: '/cart/change.js',
        data: {
          'id': key,
          'quantity': quantity,
          'selling_plan': planID,
          'sections': sections
        },
        dataType: 'json',
        beforeSend: function () {
          $this.parent('.line-item-bottom').find('.upgrading-plan').removeClass('hidden');
          $this.parent('.line-item-bottom').find('.plan-selection').addClass('hidden');
          $this.parent('.line-item-bottom').find('svg.icon').addClass('hidden');
        },
        error: function(error) {
          console.log(error);
        },
        success: function(response) {
          changeLineItemContent_fn($this[0], key, response);
        }
      });
    }
  });

  /** Subscribe Option Check */
  var initialSubscription = () => {
    // var discountVal = $('input#subscription-save').data('discount-val');

    if ( $('input#subscription-save').is(':checked') ) {
      $('.styled-variant-picker__option .block-swatch').each(function() {
        var $this = $(this),
            discountVal = $this.find('.price-off').data('subscribe-value'),
            priceOffFormat = discountVal / 100;

        if ( $('.product-info-inner').data('product-handle').includes('whole-in-one') ) {
          priceOffFormat = priceOffFormat.toFixed(2);
        } else {
          priceOffFormat = Math.floor(priceOffFormat);
        }

        $this.find('.price-off').text('Save $'+ priceOffFormat);

        if ( $this.prev('input:checked').length > 0 ) {
          $('.selection-price-wrap .radio-item label .discount').text('$' + priceOffFormat + ' off');
          // $('.subscribe-selection-value .description-list .price-off').text('$' + priceOffFormat);
        }
      });

      var planID = $('.subscribe-selection-value .plan-selection').val();

      $('#subscription-plan-id').val(planID);
      $('#subscription-plan-id').attr('name', 'selling_plan');
    } else {
      $('.styled-variant-picker__option .block-swatch').each(function() {
        var $this = $(this),
            variantDiscountVal = $this.find('.price-off').data('value'),
            priceOffFormat = variantDiscountVal/100;

        if ( $('.product-info-inner').data('product-handle').includes('whole-in-one') ) {
          priceOffFormat = priceOffFormat.toFixed(2);
        } else {
          priceOffFormat = Math.floor(priceOffFormat);
        }
        
        if ( variantDiscountVal == 0 ) {
          $this.find('.price-off').text('No Discount');
        } else {
          $this.find('.price-off').text('Save $' + priceOffFormat);
        }
      });

      $('#subscription-plan-id').attr('name', '');
    }
  }

  function cleanPrice(priceHTML) {
    let price = priceHTML.replace(/[^\d.]/g, '');

    if(price.startsWith(".")){
      price = price.slice(1)
    }

    price = parseInt(price)
    return price
  }

  /** Add to Cart Button Value Set */
    var cartButtonValueSet = () => {
    var checkedVariant = $('.styled-variant-picker__option :checked+.block-swatch'),
        checkedSelection = $('.subscribe-selection-value.active'),
        priceOffTxt = checkedVariant.find('.price-off').text(),
        discountPrice = checkedSelection.find('.discount-price').text()
        buttnTxt = $('.product-add-to-cart').text();

    if ( buttnTxt.indexOf('Add to cart') == -1 && buttnTxt.indexOf('Subscribe') == -1 ) return;

    var isSubscriptionSelected = $('input#subscription-save').is(':checked');
    var buttonLabel = isSubscriptionSelected ? 'Subscribe now' : 'Add to cart';
    var updatedBtnText = '<span class="btn-label">' + buttonLabel + ' - ' + discountPrice + '</span>';

    const cleanedPrice = cleanPrice(discountPrice)

    var multiplier = isSubscriptionSelected ? 5 : 1;

    let event = new CustomEvent('sharedsweeps-product-page:price:change', {
      detail: { price: cleanedPrice, multiplier: multiplier, isSubscriptionSelected }
    });

    document.dispatchEvent(event);
    // Custom Event

    if ( priceOffTxt != 'No Discount' && priceOffTxt != '' ) updatedBtnText = updatedBtnText + '<span class="saving">You\'re Saving ' + priceOffTxt.replace('Save ', '') + '</span>';
    $('.product-add-to-cart').empty().append(updatedBtnText);
  }

  if ( $('.subscribe-selection-wrapper').length > 0 ) {
    initialSubscription();
    cartButtonValueSet();
  } 

  $('.subscribe-selection-value .plan-selection').on('change', function() {
    var planID = $(this).val();
    $('#subscription-plan-id').val(planID);
  });

  $('body').on('click', '.subscribe-selection-value', function(e) {
    var $this = $(this);

    if ( ! $(e.target).is('.change-plan') && ! $this.hasClass('active') ) {
      $('.subscribe-selection-value').removeClass('active');
      $this.addClass('active');
      $this.find('input').prop('checked', true);
      initialSubscription();
      cartButtonValueSet();
    }

  });

  $('.styled-variant-picker__option .block-swatch').on('click', function() {
    var $this = $(this),
        discountVal = $this.find('.price-off').data('subscribe-value'),
        priceOffFormat = discountVal / 100;

        if ( $('.product-info-inner').data('product-handle').includes('whole-in-one') ) {
          priceOffFormat = priceOffFormat.toFixed(2);
        } else {
          priceOffFormat = Math.floor(priceOffFormat);
        }
    
    $('.selection-price-wrap .radio-item label .discount').text('$' + priceOffFormat + ' off');
    // $('.subscribe-selection-value .description-list .price-off').text('$' + priceOffFormat);
  });

  $(document).on('variant:change', function(e) {
    if (e.originalEvent.detail.variant.selling_plan_allocations.length > 0) {
      var selectedVariant = e.originalEvent.detail.variant,
          comparePrice = selectedVariant.compare_at_price,
          price = selectedVariant.price,
          packCount = 1,
          sellingPlanPrice = selectedVariant.selling_plan_allocations[0].price;

      if ( selectedVariant.title == 'Double Pack' || selectedVariant.title == '2 Pack' ) {
        packCount = 2;
      } else if ( selectedVariant.title == 'Family Pack' || selectedVariant.title == '3 Pack' ) {
        packCount = 3;
      }

      if ( comparePrice == null ) comparePrice = price;
      $('.selection-price-wrap .price-value .compare-price').text('$ ' + (comparePrice / 100).toFixed(2));
      $('.selection-price-wrap .subscribe-price .discount-price').text('$ ' + (sellingPlanPrice / 100).toFixed(2));
      $('.selection-price-wrap .onetime-price .discount-price').text('$ ' + (price / 100).toFixed(2));

      if ( comparePrice == price ) {
        $('.selection-price-wrap .onetime-price .compare-price').addClass('hidden');
      } else {
        $('.selection-price-wrap .onetime-price .compare-price').removeClass('hidden');
      }

      $('.subscribe-selection-value .description-list .subscribe-pack-price').text('$' + (sellingPlanPrice / packCount / 100).toFixed(2));
      $('.subscribe-selection-value .description-list .pack-price').text('$' + (price / packCount / 100).toFixed(2));
      let packCountText = packCount + ' bottle';
      if (packCount > 1) {
        packCountText += 's';
      }
      $('.subscribe-selection-value .description-list .pack-count').text(packCountText);
      cartButtonValueSet();
    }
    else {
      if ($('.price-off')) {
        let selectedVariant = e.originalEvent.detail.variant;
        let price = selectedVariant.price;
        let comparePrice = selectedVariant.compare_at_price;
        var isSubscriptionSelected = $('input#subscription-save').is(':checked');
        var buttonLabel = isSubscriptionSelected ? 'Subscribe now' : 'Add to cart';
        let updatedBtnText = '<span class="btn-label">' + buttonLabel + ' - $' + (price / 100).toFixed(2) + '</span>';
        var checkedVariant = $('.styled-variant-picker__option :checked+.block-swatch'),
            priceOffTxt = checkedVariant.find('.price-off').text();
        if (comparePrice > price) {
          updatedBtnText += '<span class="saving">You’re Saving ' + priceOffTxt.replace('Save ', '') + '</span>';
        }
        $('.product-add-to-cart').empty().append(updatedBtnText);
      }
    }
  });

  $('.subscribe-selection-value .description-list .change-plan').on('click', function() {
    $('.subscribe-selection-value:first-child').trigger('click');
  });

  /* VS Testimonials */
  $('.vs-testimonials-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
    touchThreshold: 100,
    prevArrow: '<button class="slick-prev slick-arrow"><svg width="50" height="18" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
    nextArrow: '<button class="slick-next slick-arrow"><svg width="50" height="18" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        }
      },
    ]
  });

  /* Cart Page Redirect */
  if ( window.location.pathname == '/cart' ) {
    window.location.href="/#cart";
  }

  if ( window.location.hash == '#cart' ) {
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true,
      detail: {
        baseEvent: "force_show"
      }
    }));
  }

  /* Product Card */
  $(document).on('change', '.subscription-checkbox__input', function () {

    let priceHTML;

    if ($(this).prop('checked') == true) {
      $(this).parents('form').find('.product-card__select--plan').addClass('product-card__select--active');
      $(this).parents('form').find('.product-card__select--plan').attr('name', 'selling_plan');
      $(this).parents('.product-card').find('.product-card__price--sale').text($(this).parents('form').find('.product-card__select--variants option:selected').attr('data-subscription-price'));
      priceHTML = $(this).parents('form').find('.product-card__select--variants option:selected').attr('data-subscription-price');

    }

    else {
      $(this).parents('form').find('.product-card__select--plan').removeClass('product-card__select--active');
      $(this).parents('form').find('.product-card__select--plan').attr('name', '');
      $(this).parents('.product-card').find('.product-card__price--sale').text($(this).parents('form').find('.product-card__select--variants option:selected').attr('data-price'));
      priceHTML = $(this).parents('form').find('.product-card__select--variants option:selected').attr('data-price');

    }

    let price = cleanPrice(priceHTML);
    let productId = $(this).parents('form').find('input[data-product-id]').data('product-id');
    productId = productId.split('-')[2];

    let isSubscriptionSelected = $(this).prop('checked');
    let multiplier = isSubscriptionSelected ? 5 : 1;

    let event = new CustomEvent('sharedsweeps-product:price:change', {
      detail: { price, productId, multiplier, isSubscriptionSelected }
    });

    document.dispatchEvent(event);

  });

    $(document).on('change', '.product-card__select--variants', function () {
    $(this).parents('.product-card').find('.product-card__media img').attr('src', $(this).find('option:selected').attr('data-image'));
    $(this).parents('.product-card').find('.product-card__media img').attr('srcset', '');
    if ($(this).find('option:selected').attr('data-compare-price')) {
      $(this).parents('.product-card').find('.product-card__price--compare').text($(this).find('option:selected').attr('data-compare-price'));
    }

    let price;

    if ($(this).parents('form').find('.subscription-checkbox__input').prop('checked') == true) {
      price = $(this).parents('form').find('.product-card__select--variants option:selected').attr('data-subscription-price');
      $(this).parents('.product-card').find('.product-card__price--sale').text($(this).parents('form').find('.product-card__select--variants option:selected').attr('data-subscription-price'));
    }
    else {
      price = $(this).parents('form').find('.product-card__select--variants option:selected').attr('data-price');
      $(this).parents('.product-card').find('.product-card__price--sale').text($(this).parents('form').find('.product-card__select--variants option:selected').attr('data-price'));
    }

    price = cleanPrice(price);
    let productId = $(this).parents('form').find('input[data-product-id]').data('product-id');
    productId = productId.split('-')[2];
    let isSubscriptionSelected = $(this).parents('form').find('.subscription-checkbox__input').prop('checked');
    let multiplier = isSubscriptionSelected ? 5 : 1;
    // Send Price & Product ID on document event
    let event = new CustomEvent('sharedsweeps-product:price:change', {
      detail: { price, productId, multiplier, isSubscriptionSelected }
    });

    document.dispatchEvent(event);

  });
  
  // Splash Animation
  if ($('.splash-bg').length) {
    var loaded = 0;
    $(".splash-bg img, .splash-fg img").one("load", function() {
      loaded ++;
      if (loaded == 2) {
        setTimeout(function () {
          $('.splash-bg').addClass('active');
          $('.splash-fg').addClass('active');
        }, 1000);
      }
    }).each(function() {
      if(this.complete) {
        $(this).trigger('load');
      }
    });
  }

  // Close Products + Mega menu on Escape key
  $(document).on('keydown', function(event) {
    if (event.key === 'Escape') {
        $('details[is="mega-menu-disclosure"]').removeAttr('open'); // Close the menu
    }
  });

  // Remove tabindex attribute from product listings
  setInterval(function() {
    $('.product-list--carousel-custom .product-card').removeAttr('tabindex');
    $('.product-list--carousel-custom .product-card .product-card__media').attr('tabindex','-1');
    $('.product-list--carousel-custom .product-card .product-card__media').attr('aria-hidden','true');
  }, 500);

  // Adding page specific attributes
  $curloc = $(location).attr('href');
  console.log($curloc);

  switch($curloc) {
    case "https://brickhousenutrition.com/pages/about-us-1" :
      $('image-with-text-overlay img').attr('aria-hidden','true');
      $('.multi-column .h3').attr('role','heading');
      $('.multi-column .h3').attr('aria-level','3');
      $('.multi-column img').attr('aria-hidden','true');
      break;
    case "https://brickhousenutrition.com/products/field-of-greens-bundle?_pos=1&_sid=279d6faab&_ss=r" :
      $(window).on('load', function() {
          $('input.rb-input').attr('aria-live','polite');
          $('.rb-qty-wrapper').each(function() {
            $productName = $('label', this).html();
            console.log($productName);
            $('button.rb-btn-qty-plus', this).attr('aria-label','Add ' + $productName);
            $('button.rb-btn-qty-minus', this).attr('aria-label','Minus ' + $productName);
          });
      }); 
      break;
  }
  
});